export default __webpack_public_path__ + "static/media/cross.d2bbc7f7.svg";